import React from "react";
import "./FooterTemplate.scss";
import { createTheme, ThemeProvider, Container } from "@mui/material";
import Link from "@mui/material/Link";
import logoBlue from "../../images/logo-blue.png";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PhoneIcon from "@mui/icons-material/Phone";
import MailIcon from "@mui/icons-material/Mail";
import { getCurrentYear } from "../../utils/Utils";

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1620,
        },
    },
});

const FooterTemplate: React.FC = () => {
    return (
        <footer>
            <ThemeProvider theme={theme}>
                <Container maxWidth="xl">
                    <div className="bt-1 py-8">
                        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,2.6fr)_auto] lg:items-start lg:gap-10">
                            <div className="footer-left flex flex-col">
                                <Link
                                    href="/home"
                                    className="mb-3! inline-flex max-w-full items-center"
                                >
                                    <img
                                        src={logoBlue}
                                        alt="AaNeel Connect"
                                        className="h-auto w-auto max-w-[168px] sm:max-w-[196px]"
                                    />
                                </Link>
                                <div className="text-sm text-(--verydarkbluecustom)">
                                    © {getCurrentYear()} AaNeel Infotech, LLC.
                                </div>
                            </div>

                            <div className="footer-right grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-4 xl:gap-8">
                                <ul className="flex flex-col gap-2 text-sm">
                                    <li className="flex items-center gap-3 text-(--verydarkbluecustom)">
                                        <PhoneIcon className="mt-0.5 shrink-0" />
                                        <div className="min-w-0 font-medium break-words">
                                            Sales:&nbsp;
                                            <a href="tel:+18139099555">
                                                +1 (813) 909-9555
                                            </a>
                                        </div>
                                    </li>
                                    <li className="flex items-center gap-3 text-(--verydarkbluecustom)">
                                        <MailIcon className="mt-0.5 shrink-0" />
                                        <div className="min-w-0 font-medium break-all">
                                            <a href="mailto:Sales@aaneel.com">
                                                Sales@aaneel.com
                                            </a>
                                        </div>
                                    </li>
                                </ul>

                                <div className="text-sm leading-7 text-(--verydarkbluecustom)">
                                    6650 Gunn Hwy,
                                    <br />
                                    Tampa, FL 33625
                                </div>

                                <ul className="flex flex-col gap-1 text-(--moderatevioletcustom)">
                                    <li className="text-sm font-medium">
                                        <a href="/home">Home</a>
                                    </li>
                                    <li className="text-sm font-medium">
                                        <a href="/providerdirectory/location-api/location">
                                            AaNeel Connect API
                                        </a>
                                    </li>
                                </ul>

                                <ul className="flex flex-col gap-1 text-(--verydarkbluecustom)">
                                    <li className="text-sm font-medium">
                                        <a href="/privacy-policy">Privacy Policy</a>
                                    </li>
                                    <li className="text-sm font-medium">
                                        <a href="/terms-of-service">Terms of service</a>
                                    </li>
                                </ul>
                            </div>

                            <div className="social-box flex lg:justify-end">
                                <div className="social-icons">
                                    <Link
                                        className="linkedin"
                                        href="https://www.linkedin.com/company/aaneel-usa/mycompany/"
                                        target="_blank"
                                    >
                                        <LinkedInIcon />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </ThemeProvider>
        </footer>
    );
};

export default FooterTemplate;
